module.exports = __webpack_public_path__ + "static/media/mclloyd-header.775f4bf7.png";